import React from 'react';
import {
  getRoleMeta,
  getSectionItems,
  getFlagCounts,
  getTotalFlags,
  FLAG_SECTION_KEYS,
  PERSPECTIVE_SECTIONS,
} from './perspectivesModel';

const PerspectiveCard = ({ role, perspective }) => {
  const meta = getRoleMeta(role);
  const counts = getFlagCounts(perspective);
  const totalFlags = getTotalFlags(perspective);

  return (
    <article className={`perspective-card ${meta.className}`}>
      <header className="perspective-card-header">
        <span className="perspective-icon" aria-hidden="true">
          {meta.icon}
        </span>
        <div className="perspective-title">
          <h4>{meta.title}</h4>
          <p className="perspective-subtitle">{meta.subtitle}</p>
        </div>
        {totalFlags > 0 && (
          <span className="perspective-flag-badge" title={`${totalFlags} data flags identified`}>
            ⚑ {totalFlags} flag{totalFlags === 1 ? '' : 's'}
          </span>
        )}
      </header>

      <div className="perspective-sections">
        {PERSPECTIVE_SECTIONS.map((section) => {
          const items = getSectionItems(perspective, section.key);
          const isFlag = FLAG_SECTION_KEYS.includes(section.key);
          const count = counts[section.key] || 0;
          return (
            <div
              className={`perspective-section${isFlag ? ' flag-section' : ''}`}
              key={section.key}
            >
              <h5>
                <span className="perspective-section-icon" aria-hidden="true">
                  {section.icon}
                </span>
                {section.label}
                {isFlag && count > 0 && (
                  <span className="perspective-count-badge">{count}</span>
                )}
              </h5>
              {items.length > 0 ? (
                <ul>
                  {items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="perspective-empty">None noted.</p>
              )}
            </div>
          );
        })}
      </div>
    </article>
  );
};

export default PerspectiveCard;
